module.exports = __webpack_public_path__ + "media/application/images/test-pic-c01def9b34a2e76a8cb1dec53d46907b.png";